var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon__link",
  viewBox: "0 0 24 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 17.549,
  y: -0.021,
  width: 6.553,
  height: 11.922,
  rx: 3.277,
  transform: "rotate(45 17.549 -.021)",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10.75,
  y: 1.909,
  width: 6.553,
  height: 11.922,
  rx: 3.277,
  transform: "rotate(45 10.75 1.91)",
  stroke: "currentColor",
  strokeWidth: 1.5
})));
export default SvgLink;